export default{
	data(){
		return{
			imageLoadFailed:false,
		}
	},
	methods:{
		avatarImage(url){
			// return this.imageLoadFailed ? require("../assets/bindez-new-logo.png") : url;
			return this.imageLoadFailed ? url : url;
		},

		avatarImageErrorHandler(){
			this.imageLoadFailed = true;
		}

	}
}
